import React, { useState } from "react";
import {
  Table,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import Document from "./Document";

const DocumentHistoryTable = ({
  documentHistory,
  title = "Document Events",
  onViewDocument,
  documentType = "CONTRACT", // New prop to specify document type
}) => {
  console.log(
    "DocumentHistoryTable received documentHistory:",
    documentHistory
  );
  console.log("documentHistory type:", typeof documentHistory);
  console.log("documentHistory is array:", Array.isArray(documentHistory));
  if (Array.isArray(documentHistory)) {
    console.log("documentHistory length:", documentHistory.length);
    console.log("First item:", documentHistory[0]);
  }
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);

  const toggleModal = () => {
    setModalOpen(!modalOpen);
    if (!modalOpen) {
      setSelectedDocument(null);
    }
  };

  // Get document type label for display
  const getDocumentTypeLabel = () => {
    return documentType === "ADDENDUM" ? "Addendum" : "Contract";
  };

  // Handle both old and new payload structures
  // New structure: Array of webhook events
  // Old structure: { activities: [...], envelopeInfo: {...} }
  let activities = [];
  let envelopeStatus = "Unknown";

  if (Array.isArray(documentHistory)) {
    // New webhook format - array of events
    activities = documentHistory;
    console.log("Using new webhook format - activities:", activities);
  } else if (documentHistory?.activities) {
    // Old format - object with activities array
    activities = documentHistory.activities;
    envelopeStatus = documentHistory?.envelopeInfo?.status || "Unknown";
    console.log("Using old format - activities:", activities);
  }

  console.log("Processed activities:", activities);

  if (!documentHistory || activities.length === 0) {
    return (
      <div className="text-center text-muted py-4">
        <i className="ni ni-folder-17" style={{ fontSize: "2rem" }} />
        <p className="mt-2 mb-0">
          No {getDocumentTypeLabel().toLowerCase()} events available
        </p>
      </div>
    );
  }

  return (
    <div>
      {/* {title && <h6 className="mb-3">{title}</h6>} */}
      <div className="table-responsive">
        <Table className="align-items-center table-flush" responsive size="sm">
          <thead className="thead-light">
            <tr>
              <th scope="col">User</th>
              <th scope="col">Action</th>
              <th scope="col">Activity</th>
              <th scope="col">Status</th>
              <th scope="col">Created</th>
            </tr>
          </thead>
          <tbody>
            {activities.map((activity, index) => (
              <tr key={index} style={{ backgroundColor: "#f8f9fa" }}>
                <td>
                  {activity.user || "-"}
                  {activity.recipientInfo && (
                    <div className="text-muted small">
                      {activity.recipientInfo.email}
                    </div>
                  )}
                  {activity.recipientId && (
                    <div className="text-muted small">
                      Recipient ID: {activity.recipientId}
                    </div>
                  )}
                </td>
                <td>
                  <div>{activity.action || "-"}</div>
                  {activity.eventType && (
                    <div className="text-muted small">
                      {activity.eventType}
                    </div>
                  )}
                </td>
                <td>{activity.activity || "-"}</td>
                <td>
                  {activity.status || "-"}
                </td>
                <td>
                  {activity.created || activity.time
                    ? new Date(activity.created || activity.time).toLocaleString()
                    : "-"}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      {/* Document Details Modal */}
      <Modal isOpen={modalOpen} toggle={toggleModal} size="lg">
        <ModalHeader toggle={toggleModal}>
          {getDocumentTypeLabel()} Details
        </ModalHeader>
        <ModalBody className="p-0">
          {selectedDocument && (
            <Document
              documentEvent={selectedDocument}
              file={
                selectedDocument.file || selectedDocument.documentUrl || null
              }
              title={`${getDocumentTypeLabel()} Information`}
              alwaysExpanded={true}
              documentType={documentType}
            />
          )}
        </ModalBody>
      </Modal>
    </div>
  );
};

export default DocumentHistoryTable;
